import axios from "axios";

export default {
  strict: true,
  namespaced: true,
  state: {
    roles: null,
    secondaryRole: null,
  },
  getters: {
    roles: (state) => state.roles,
    // predictile
    isPredictile: (state, getters) => () => !!getters.roles && !!getters.roles["predictile"] && getters.roles["predictile"].length > 0,
    isPredictileAdministrator: (state, getters) => () => !!getters.roles && !!getters.roles["predictile"] && getters.hasRole("predictile", ["predictile_administrator"]),
    isPredictileManagement: (state, getters) => () =>
      !!getters.roles && !!getters.roles["predictile"] && getters.hasRole("predictile", ["predictile_administrator", "predictile_management"]),
    isPredictileOperations: (state, getters) => () =>
      !!getters.roles && !!getters.roles["predictile"] && getters.hasRole("predictile", ["predictile_administrator", "predictile_management", "predictile_operations"]),
    // business
    isBusinessAdministrator: (state, getters) => (businessId) => getters.hasRole(businessId, ["business_administrator"]),
    isBusinessManagement: (state, getters) => (businessId) => getters.hasRole(businessId, ["business_administrator", "business_management"]),
    isBusinessOperations: (state, getters) => (businessId) => getters.hasRole(businessId, ["business_administrator", "business_management", "business_operations"]),
    // common
    hasRole: (state) => (organizationId, roles) => {
      var hasAny = false;
      if (state.roles && state.roles[organizationId]) {
        for (let i = 0; i < roles.length; i++) {
          hasAny = hasAny || state.roles[organizationId].indexOf(roles[i]) > -1;
        }
      }
      return hasAny;
    },
    isLocationFiltered: (state, getters, rootState, rootGetters) => {
      var locations = rootGetters["location/locations"];
      var isFiltered = false;

      if (rootGetters["organization/organization"].type === "business") {
        for (let i = 0; i < locations.length; i++) {
          for (const currentRole in getters.roles) {
            if (currentRole === locations[i].businessLocationId) isFiltered = true;
          }
        }
      }
      return isFiltered;
    },
    secondaryRole: (state) => state.secondaryRole,
    isPscSecondaryRole: (state) => state.secondaryRole === "psc",
  },
  mutations: {
    setRoles(state, payload) {
      state.roles = payload;
    },
    setSecondaryRole(state, payload) {
      state.secondaryRole = payload;
    },
  },
  actions: {
    init: async (context) => {
      if (!context.rootGetters["cognito/isAuthenticated"]) {
        context.commit("setRoles", null);
        context.commit("setSecondaryRole", null);
        return;
      }
      try {
        const res = await axios.get(`/users/self/roles`);
        const map = {};
        let secondaryRole = null;
        for (const role of res.data) {
          map[role.entityId] = role.roles;
          if (role.secondaryRole !== undefined && role.secondaryRole !== null) {
            secondaryRole = role.secondaryRole;
          }
        }
        context.commit("setRoles", map);
        context.commit("setSecondaryRole", secondaryRole);
        return Promise.resolve();
      } catch {
        context.commit("setRoles", null);
        context.commit("setSecondaryRole", null);
      }
    },
    clearRoles: async (context) => {
      context.commit("setRoles", null);
      context.commit("setSecondaryRole", null);
    },
  },
};
